export const SkillsData = [
    {
        type:"Frontend",
        list:[
            {
                name:"ReactJS",
                icon:<i class="devicon-react-original colored"></i>
            },
            {
                name:"Sass",
                icon:<i class="devicon-sass-original colored"></i>
            },
            {
                name:"Redux",
                icon:<i class="devicon-redux-original colored"></i>
            },
            {
                name:"TailWind CSS",
                icon:<i class="devicon-tailwindcss-plain colored"></i>
            },
        ]
    },
    {
        type:"Backend",
        list:[
            {
                name:"C++",
                icon:<i class="devicon-cplusplus-plain colored"></i>
            },
            {
                name:"NodeJS",
                icon:<i class="devicon-nodejs-plain colored"></i>
            },
        ]
    }
];